import gCard from "@/components/g-card/g-card.vue";
import gForm from "@/components/g-form/g-form.vue";
import gDateInput from "@/components/g-date-input/g-date-input.vue";
import gButton from "@/components/g-button/g-button.vue";
import gDataTable from "@/components/g-data-table/g-data-table.vue";
import ProdutoController from "@/shared/controllers/produto/produtoController";
import OrcamentoProdutoController from "@/shared/controllers/orcamentoProduto/OrcamentoProdutoController";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import CartaPropostaController from "@/shared/controllers/cartaProposta/CartaPropostaController";
import FiltroCartaPropostaEmDigitacao from "@/shared/view-models/Filtros/FiltroCartaPropostaEmDigitacao";
import { defineComponent } from "vue";
import EVENTS from "@/shared/events/events";

const name = 'cartapropostaemdigitacao'
export default defineComponent({
  name,

  components: {
    'g-card': gCard,
    'g-form': gForm,
    'g-date-input':gDateInput,
    'g-button': gButton,
    'g-data-table': gDataTable
  },

  props: { },

  mounted () {
    this.UnidadeArray = this.$store.state.EmpresaArray;
    this.objFiltros.RepresentanteId = this.$store.state.representanteSelecionadoId;
    this.OrcamentoProdutoArray = OrcamentoProdutoController.GetOrcamentoProdutoAtivos().OrcamentoProdutoArray;
    this.StatusArray = CartaPropostaController.GetInformacaoStatusCartaEnum().StatusArray;

    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.atualizaEmpresaRepresentante()
    })
  },

  updated () { },

  data () {
    return {
      CartasPropostaDigitacaoArray: [],
      orcamentoArray: [],
      ClienteArray: [],
      checkboxConsultarDados: false,
      informacaoCartPropSelecionada: null,
      mensagemvazio: true,
      objFiltros: new FiltroCartaPropostaEmDigitacao(),
      OrcamentoProdutoArray:[],
      popup: false,
      popupExcluir: false,
      ProdutoArray: [],
      StatusArray: [],
      UnidadeArray: [],
      CartaPropostaInfoLinha: [],
        Colunas: [
          {field: 'codigoExterno', header: 'Nº Carta', width: '50px', ordena: true},
          {field: 'dataInclusaoFormatada', header: 'Data', width: '100px', ordena: true, ordenacao: 'dataInclusaoFormatada'},
          {field: 'nomeRepresentante', header: 'Representante', width: '300px', ordena: true},
          {field: 'curvaCliente', header: 'CV', width: '50px', ordena: true},
        ],
        ColunasSubGrid: [
          {field: 'numeroSolicitacao', header: 'N° Solicitação', width: '80px', ordena: true},
          {field: 'dataDigitacaoFormatadaText', header: 'Dt. Digitação', width: '100px', ordena: true, ordenacao: 'dataDigitacao'},
          {field: 'nomeProduto', header: 'Nome Produto', width: '350px', ordena: true},
          {field: 'orcamentoSituacaoEnum', header: 'Status', width: '250px', ordena: true},
          {field: 'tipoText', header: 'Tipo', width: '260px', ordena: true},
        ],
        Filtro: {
          'global': {value: null, matchMode: this.filtros.CONTAINS},
          'codigoExterno': {value: null, matchMode: this.filtros.CONTAINS},
          'dataInclusaoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeEmpresa': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeRepresentante': {value: null, matchMode: this.filtros.CONTAINS},
          'razaoSocial': {value: null, matchMode: this.filtros.CONTAINS},
          'CV': {value: null, matchMode: this.filtros.CONTAINS},
        },
        timer: null,
        cartasExpandidas: [],
        valueExpander: 0,
        trazBtnExpandirTodos: false
    }
  },

  methods: {
    ExpandeAllRows() {
      if(this.valueExpander == 0) {
        this.valueExpander = 1
        this.cartasExpandidas = this.CartasPropostaDigitacaoArray.filter((p) => p.id)
      } else {
        this.valueExpander = 0
        this.cartasExpandidas = []
      }
    },

    excluir(CartasPropostaDigitacaoArray) {
      this.$isLoading(true)
      
      let CartaPropostaId = CartasPropostaDigitacaoArray.id
      CartaPropostaController.ExcluirCartaPropostaDigitacao(CartaPropostaId).requisicao
      
      .then(res => {
        if(res.data.data) {
          this.$toast.add({ severity: 'success', summary: 'Carta-proposta deletada!', life: 3200 });

          this.popupExcluir = false,
          this.GetCartaPropostaDigitacaoByFiltro

          return
        } else {
          this.$toast.add({ severity: 'error', summary: 'Erro ao deletar a carta-proposta.', life: 3200 });
        }
      })
      .catch(() => {
        this.$isLoading(false)
      })
      .finally(() => {
        this.$isLoading(false),
        this.GetCartaPropostaDigitacaoByFiltro() 
      })
    },

    atualizaEmpresaRepresentante(){
      // this.objFiltros.UnidadeId = this.$store.state.empresaSelecionadaId;
      this.objFiltros.RepresentanteId = this.$store.state.representanteSelecionadoId;
    },

    buscarClientes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ClienteArray = ClienteController.getClienteDropDownsByNome(event, this.objFiltros.UnidadeId, this.objFiltros.RepresentanteId).ClientesArray;
      }, 1000);
    },
    GetOrcamentoByCartaPropostaId(CartasPropostaDigitacaoArray){

        this.orcamentoArray = OrcamentoController.GetOrcamentoByCartaPropostaId(CartasPropostaDigitacaoArray).requisicao
          .then(response => {
            this.orcamentoArray = response.data.data
          });
    },
    buscarProdutos(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ProdutoArray = ProdutoController.GetProdutoDropDownByPesquisaRepresentanteEmpresa(event, this.objFiltros.RepresentanteId, this.objFiltros.UnidadeId ).ProdutoArray;
      }, 1000);
    },
    CartasPropostaDigitacaoAtivas() {
      this.axios({
        method: 'Get',
        url: process.env.VUE_APP_WEB_API +  `CartaProposta/GetCartasPropostasDigitacao/Get`,
      })
      .then((response) => {
        this.CartasPropostaDigitacaoArray = response.data.data
      })
      .catch(() => {
      })
    },

    Grid() {
      this.mensagemvazio=false
      this.trazBtnExpandirTodos = true
      this.GetCartaPropostaDigitacaoByFiltro()
    },

    ContinuarCartProp(CartasPropostaDigitacaoArray) {
      let CartaPropostaId = CartasPropostaDigitacaoArray.id
      this.$router.push(`/gerar-carta-proposta/${CartaPropostaId}/orcamento`)
    },

    redireciona(){
      this.ContinuarCartProp(this.informacaoCartPropSelecionada)
    },

    abrePopup (infoRegistro) {
      this.popup=true
      this.informacaoCartPropSelecionada = infoRegistro
    }, 

    fechaPopup(){
      this.popup = false
    },

    abrePopupExcluir (CartasPropostaDigitacaoArray) {
      this.popupExcluir=true
      this.CartaPropostaInfoLinha = CartasPropostaDigitacaoArray      
    },

    fechaPopupExcluir(){
      this.popupExcluir = false
    },

    GetCartaPropostaDigitacaoByFiltro(){
      this.$isLoading(true)
      CartaPropostaController.GetCartaPropostaDigitacaoByFiltro(this.objFiltros).requisicao
      .then(response => {
        this.CartasPropostaDigitacaoArray = response.data.data;

        this.valueExpander = 1
        this.cartasExpandidas = this.CartasPropostaDigitacaoArray.filter((p) => p.id)
        this.$isLoading(false)
      })
      .catch(() => this.$isLoading(false))
    },

    clear(){
      this.objFiltros = new FiltroCartaPropostaEmDigitacao();

      this.atualizaEmpresaRepresentante()
    },

  },
});